import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-search',
  standalone: true,
  imports: [],
  templateUrl: './input-search.component.html',
  styleUrl: './input-search.component.scss',
})
export class InputSearchComponent {
  @Input() placeholder = '';
  @Output() searchChange = new EventEmitter<string>();

  onSearchUpdated(searchValue: string) {
    this.searchChange.emit(searchValue);
  }

  clearSearch(input: HTMLInputElement) {
    input.value = '';
    this.onSearchUpdated('');
  }
}
